export default {"src":"/_next/static/media/sort.e5372fe7.svg","height":22,"width":25,"blurWidth":0,"blurHeight":0};